import {mapGetters} from 'vuex';
import permissions from '@/libs/constant/permissions'

export default{
    name: 'card',
    computed: {
        ...mapGetters(['hasPermission'])
    },
    data() {
        return {
            permissions: permissions
        }
    }
}